import { Component } from '@angular/core';

@Component({
    selector: 'app-tasks-json',
    templateUrl: './tasks-json.component.html',
    styleUrl: './tasks-json.component.less',
    standalone: false
})
export class TasksJsonComponent {

}
